class RequiredFieldsForm {
  constructor(element) {
    this.element = element;
    this.button = element.find("button");

    this.element.find("[required]").change((e) => {
      this.update();
    });

    this.update();
  }

  update() {
    if ($(this.element).is(":invalid")) {
      this.button.attr("disabled", true);
    } else {
      this.button.attr("disabled", false);
    }
  }
}

$(document).on("turbo:load", () => {
  $("[data-behavior=required-fields-form]").each(function () {
    new RequiredFieldsForm($(this));
  });
});

$(document).on("turbolinks:restore", () => {
  $("[data-behavior=required-fields-form]").each(function () {
    new RequiredFieldsForm($(this));
  });
});
